import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TandemFloatingMenu',
  setup(__props) {

const showMenu = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["floating-menu jump-to-menu", { open: showMenu.value }])
  }, [
    _createElementVNode("div", {
      class: "menu-header yellow-bkg",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu.value = !showMenu.value))
    }, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    (showMenu.value)
      ? _renderSlot(_ctx.$slots, "content", { key: 0 })
      : _createCommentVNode("", true)
  ], 2))
}
}

})